import fs from 'node:fs'

export function ensureLine(filePath: string, line: string, comment?: string): void {
  const existing = fs.existsSync(filePath) ? fs.readFileSync(filePath, 'utf-8') : ''
  const lines = existing === '' ? [] : existing.split('\n')

  if (lines.includes(line)) {
    return
  }

  const nextLines = lines.filter(Boolean)
  if (comment && !nextLines.includes(comment)) {
    nextLines.push(comment)
  }
  nextLines.push(line)
  fs.writeFileSync(filePath, `${nextLines.join('\n')}\n`, 'utf-8')
}
